module.exports = __webpack_public_path__ + "img/yq7.977cb0b2.png";